export const NEW_PASSWORD = "NEW_PASSWORD"
export const NEW_PASSWORD_SUCCESS = "NEW_PASSWORD_SUCCESS"
export const NEW_PASSWORD_ERROR = "NEW_PASSWORD_ERROR"
export const NEW_PASSWORD_SET_FLAG = "NEW_PASSWORD_SET_FLAG"
